import gql from "graphql-tag";

// export const GET_TAGGED_MEDIA_QUERY = gql`
//   query GetTaggedMedia($input: TaggedMediaInput!) {
//     getTaggedMedia(input: $input) {
//       imageId
//       tags
//     }
//   }
// `;

export const GET_TAGGED_MEDIA_QUERY = gql`
  query GetTaggedMedia($input: TaggedMediaInput!) {
    getTaggedMedia(input: $input) {
      libraryCards {
        s3Url
        tags
      }
    }
  }
`;

// New query for fetching pre-signed URLs
export const GET_PRESIGNED_URLS_QUERY = gql`
  query GetPresignedUrls($input: PresignedUrlsInput!) {
    getPresignedUrls(input: $input) {
      presignedUrls
    }
  }
`;

export const GET_PRESIGNED_GET_URLS_QUERY = gql`
  query GetPresignedUrls($input: PresignedUrlsInput!) {
    getPresignedUrls(input: $input) {
      presignedUrls
    }
  }
`;
